import React, { useEffect, useState } from 'react';
//import './Page2208Style.css';

function Page2208Success() {

  const [language, setLanguage] = useState('EN');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      setLanguage(language);
      handleLanguage(language);
      return;
    }
    setLanguage(lang.toUpperCase());
    handleLanguage(lang.toUpperCase());
  }, []);

  const handleLanguage = (value) => {
    var options = document.getElementById('language');
    var spans = options.getElementsByTagName('span');
    if (value === 'EN') {
      spans[0].style.color = 'white';
      spans[1].style.color = 'black';
      options.style.background = 'linear-gradient(to right, #000 50%, #fff 50%)';
      setLanguage('EN');
      return;
    }
    spans[0].style.color = 'black';
    spans[1].style.color = 'white';
    options.style.background = 'linear-gradient(to right, #fff 50%, #000 50%)'
    setLanguage('AR');
  }

  return (
    <div className="Aa2208">
      <div className='container'>
        <div className='form-content'>
          <div className='form-content-top'>
            <div id='language' className='language'>
              <span onClick={() => handleLanguage('EN')}>EN</span>
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              <span onClick={() => handleLanguage('AR')}>AR</span>
            </div>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src={language === 'EN' ? '/kid-security-logo-en.avif' : '/kid-security-logo-ar.avif'} /></div>
          </div>
          <div className='form-content-bottom'>
            <div className='title'>
              <h4>{language === 'EN' ? 'Successful Operation' : 'تمت العملية بنجاح'}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page2208Success;